import React, {Fragment, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";
import {useHistory} from "react-router-dom";

const MySwal = withReactContent(Swal)

const NewGroupModal = (props) => {
    const {
        toggle,
        isOpen,
        groups,
        setGroups,
    } = props;

    const [name, setName] = useState("");
    const [validationFailed, setValidationFailed] = useState(false);
    const history = useHistory();


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Nova {props.isAtletikaPlivanje() ? "utrka" : "grupa"}
            </ModalHeader>
            <ModalBody>
                <Input
                    placeholder={"Naziv"}
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    invalid={name === '' && validationFailed}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                />
            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            if (validationFailed) {
                                window.alert("Please enter name");
                                return;
                            }
                            let newGroups = groups;
                            newGroups.push({
                                isNewGroup: true,
                                name,
                                teams: []
                            });
                            props.toggle();
                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Spremi</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default NewGroupModal;